import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";

const HistoryModal = ({ openModal, setOpenModal, logsData }) => {
  console.log(logsData);
  const modalRef = useRef();

  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [modalRef]);

  return (
    <>
      <Modal
        show={openModal}
        onHide={() => setOpenModal(false)}
        keyboard={false} // PreveAts closing on pressing the keyboard Esc key
        className="dashboard-modal-main ring-0 bg-opacity-60 font-userFont"
        width="560px"
        centered
      >
        <div ref={modalRef}>
          <Modal.Body className="large2">
            <div className="space-y-6 w-full">
              <div className="upload-doc-main flex justify-between my-4 md:my-7">
                <h1 className="text-xl md:text-3xl font-semibold text-[#E3D0A8] mb-3 m-auto">
                  Brouchure History
                </h1>
                <div
                  className="close_btn cursor-pointer"
                  onClick={() => {
                    setOpenModal(false);
                  }}
                >
                  <Icon
                    icon="carbon:close-filled"
                    fontSize={25}
                    color="#E3D0A8"
                  />
                </div>
              </div>
              {logsData.map((logs) => {
                console.log(logs);
                return (
                  <div key={logs.id}>
                    <div className="flex w-full rounded-lg items-center justify-between cursor-pointer shadow-sm p-4 hover:bg-[#E3D0A8] hover:bg-opacity-20 group">
                      <div className="flex items-center space-x-4 flex-1 min-w-0">
                        <div></div>
                        <h4 className="break-words">
                          <strong className="break-all">{logs.pdf_name}</strong> of chain{" "}
                          <span className="text-[#E3D0A8] text-lg font-bold">{logs.vendor_name}{" "}</span>
                           uploading <strong>{logs.status}</strong>
                        </h4>
                      </div>
                      <div className="flex items-center space-x-4 flex-shrink-0">
                        <div>{logs.created_at}</div>
                        <div className="transition-transform duration-300 ease-in-out group-hover:scale-125"></div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default HistoryModal;